import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import MatchedProperties from './components/MatchedProperties';

const matchedProperties = (props,{ t }) => (
  <Container>
    <MatchedProperties {...props} />
  </Container>
);

matchedProperties.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(matchedProperties);
